import cookie from 'cookie'

const { trunkrs_lightspeed_integration_session: token } = cookie.parse(
  document.cookie,
)

// eslint-disable-next-line import/prefer-default-export
export const getBearerToken = (): string => token
